import React from "react";

import {Budget, BudgetPayment, BudgetPaymentRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid, Stack} from "@mui/material";
import {Page, PageHeader, Panel, SoftChip} from "../../../../components/kit";
import {dateToString} from "../../../../components/utils/dates";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import {types} from "../../../../components/form/types";
import FormToggle from "../../../../components/form/form_inputs/form_toggle";
import {useNavigate, useSearchParams} from "react-router-dom";

export const BudgetPaymentEditPage = () => {
	const navigate = useNavigate();
	const apiManager = useApiManager();
	const [searchParams] = useSearchParams();
	const ctrl = apiManager.factory(BudgetPaymentRestControllerApiFactory);

	const budgetIdParam = searchParams.get("budgetId");
	const returnPath = budgetIdParam
		? `/app/admin/billing/budget/${budgetIdParam}`
		: "/app/admin/billing/budget";

	const form = useForm({
		fetcher: (id) => ctrl.getBudgetPayment(id),
		updater: (bean) => ctrl.saveBudgetPayment(bean),
		remover: (id) => ctrl.deleteOrDismissBudgetPayment(id),
		factory: () => {
			const bean: Partial<BudgetPayment> = {invoiced: false};
			if (budgetIdParam) {
				bean.budget = {id: Number(budgetIdParam)} as Budget;
			}
			return bean as BudgetPayment;
		},
		postUpdate: (bean) => {
			const targetBudgetId = budgetIdParam || (bean.budget as any)?.id;
			if (targetBudgetId) {
				navigate(`/app/admin/billing/budget/${targetBudgetId}`);
			}
		},
		postRemove: () => {
			navigate(returnPath);
		},
	} as UseFormProps<BudgetPayment>);

	return (
		<Page maxWidth={860}>
			<PageHeader back={returnPath}
						title={form.getId() ? "Pago de presupuesto" : "Nuevo pago de presupuesto"}
						subtitle="Un hito de facturación previsto del presupuesto: qué se factura y cuándo."/>
			<FormContent form={form} withoutPaper>
				<Panel>
					<FormAutocomplete field={"budget"} label={"Presupuesto"} type={types.budgets}/>

					<FormInput field={"description"} label={"Descripción de factura"}
							   helperText={"Concepto que aparecerá en la cabecera de la factura"}
							   rows={2}/>

					<FormInput field={"lineDescription"} label={"Descripción de línea"}
							   helperText={"Descripción del detalle de la línea de factura"}
							   rows={2}/>

					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<FormInput field={"amount"} type={"number"} label={"Importe neto (sin IVA)"}/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FormInput type={"date"} field={"plannedDate"} label={"Fecha prevista"}
									   helperText={"Mes en que se va a facturar"}/>
						</Grid>
					</Grid>

					<Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
						<FormToggle field={"invoiced"} label={"Marcado como facturado"}/>
						{form.value("invoiced") && (
							<SoftChip tone="success"
									  label={"Facturado el " + (form.value("invoicedAt") ? dateToString(form.value("invoicedAt")) : "—")}/>
						)}
					</Stack>
				</Panel>
			</FormContent>
		</Page>
	);
};
